import Chip from '@components/@vuexy/chips/ChipComponent'
import EquipmentIcon from '@screens/EquipmentDetail/components/EquipmentIcon'
import React from 'react'
import { Card, CardBody, Row, Col, Progress } from 'reactstrap'
import moment from 'moment-timezone'

export default ({ shop, equipment, iotData }) => {

    const operationTime = moment(shop.openDate)
    const nowDate = moment()
    const diffDuration = moment.duration(nowDate.diff(operationTime))

    let statusEquipment = equipment.parametersDetail.filter(status => status.unitGroup == "Status")
    statusEquipment.sort((firstItem, secondItem) => firstItem.id - secondItem.id)
    let numColStatus = 2
    let numRowStatus = Math.ceil(statusEquipment.length / numColStatus)
    let statusCol1 = statusEquipment.slice(0, numRowStatus)
    let statusCol2 = statusEquipment.slice(numRowStatus)

    return (
        <Col lg='6' md='6' sm='12'>
            <Card className='temp-container'>
                <CardBody className="p-1">
                    <Row className="mt-1">
                        <Col className='equipment-container' lg='5' sm='12'>
                            <Chip color={iotData && iotData.deviceStatus === 1 ? 'success' : ''} text={iotData && iotData.deviceStatus === 1 ? 'ON' : 'OFF'} />
                            <span className='operation-start'> Start {operationTime.format('D MMM YYYY')}</span>
                            <EquipmentIcon className='equipment-icon' assetTypeName={equipment.assetType} imageFilePath={equipment.imageFilePath} />
                            <OperationTime value={diffDuration.years()} unit='y' />
                            <OperationTime value={diffDuration.months()} unit='m' />
                            <OperationTime value={diffDuration.days()} unit='d' />
                            <OperationTime value={diffDuration.hours()} unit='h' />
                        </Col>
                        <Col lg='7' sm='12'>
                            <Row className="mt-1">
                                <Col className='text-info-header' lg='4'>
                                    Brand
                                </Col>
                                <Col lg='8'>
                                    {equipment.brand}
                                </Col>
                            </Row>
                            <Row>
                                <Col className='text-info-header' lg='4'>
                                    Asset No.
                                </Col>
                                <Col lg='8'>
                                    {equipment.assetNo}
                                </Col>
                            </Row>
                            <Row>
                                <Col className='text-info-header' lg='4'>
                                    Serial No.
                                </Col>
                                <Col lg='8'>
                                    {equipment.serial}
                                </Col>
                            </Row>
                            <hr className='container-divider' />
                            <Row>
                                <Col>
                                    {statusCol1.map((status, i) => renderStatus(status, iotData, i))}
                                </Col>
                                <Col>
                                    {statusCol2.map((status, i) => renderStatus(status, iotData, i))}
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Col>
    )
}

const OperationTime = ({ value, unit }) => (
    <div className='operation-time'>
        <span className='text-value'> {value} </span>
        <span className='text-unit'> {unit} </span>
    </div>

)

const ComponentStatus = ({ componentName, status }) => (
    <div className='text-status'>
        <span className={status === 1 ? 'status-on' : 'status-off'}>
            {componentName} : {status === 1 ? 'ON' : 'OFF'}
        </span>
        <Progress color={status === 1 ? 'success' : ''} value={status === 1 ? '100' : '0'} />
    </div>
)

const toCamel = (s) => {
    return s.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '')
    })
}

const renderStatus = (status, iotData, i) => {
    let statusName = status.description.split(" ", 1)[0]
    let statusParamName = toCamel(status.parameterName)
    let statusValue = (iotData) ? iotData[statusParamName] : undefined
    return (<ComponentStatus componentName={statusName} status={statusValue} key={i} />)
}
